import { useQuery } from "@hooks/useQuery";
import { Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { FieldValues } from "react-hook-form";
import { useDocumentDetails } from "~/Modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { corporateHost } from "~/Utils";
import { SingleCabinLuggagePolicySection2 } from "../SingleCabinLuggagePolicySection/SingleCabinLuggagePolicySection2";
import { SingleCabinLuggagePolicySection1 } from "../SingleCabinLuggagePolicySection/SingleCabinLuggagePolicySection1";

export const SingleCabinLuggagePolicy = () => {
  const query = useQuery();
  const navigate = useNavigate();
  
  const travellersInfoCard =[
    {
      label: "Page Content",
      key: "singleCabinLuggagePolicyPageContent",
      children: <SingleCabinLuggagePolicySection1/>
    },
    {
        label: "Page Image",
        key: "singleCabinLuggagePolicyPageImage",
        children: <SingleCabinLuggagePolicySection2/>
    }
  ]


  return (
    // <ContentWrapper>
      <Tabs
      activeKey={query?.get("fourthChildActiveTab") || ""}
      items={travellersInfoCard}
      onChange={(activeKey) => {
        navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${query.get('subActiveTab')}&thirdChildActiveTab=${query.get('thirdChildActiveTab')}&fourthChildActiveTab=${activeKey}`);
      }}
    ></Tabs>
    // </ContentWrapper>
  );
};
